import { DateValue, getLocalTimeZone, today } from "@internationalized/date";

export enum COMPANYCODE {
  VYT = "VYT",
  VY = "VY",
  ALL = "VY / VYT",
}

export enum ROLE {
  LOK = "LOK",
  KOND = "KOND",
  ALL = "ALL",
}

export type FilterType = {
  showClosed: boolean;
  showFuture: boolean;
  showDeleted: boolean;
  role: ROLE;
  companyCode: COMPANYCODE;
  chosenDate: DateValue;
};

export const initStates = {
  showClosed: false,
  showFuture: false,
  showDeleted: false,
  role: ROLE.ALL,
  companyCode: COMPANYCODE.ALL,
  chosenDate: today(getLocalTimeZone()),
};
